module.exports = __webpack_public_path__ + "media/images/icons/credit_card/visa-94bb5f3270ae4940b4ee1246c8ca9b61.png";